
<div class="border-b header border-[#edf2f9] dark:border-none bg-white dark:bg-[#323540] min-h-[72px] fixed top-0 w-full z-[1000] flex">
  <div class="border-r border-[#edf2f9] dark:border-transparent logo logo-dark transition duration-200 ease-in-out items-center h-[71px]">
    <a class="block text-center" href="">
      <img id="logo-img" class="ps-[30px]" src="assets/images/logo/logo-dark.png" alt="Logo">
      <img id="logo-fold-img" class="p-[24px] logo-fold" src="assets/images/logo/logo-fold.png" alt="Logo">
    </a>
  </div>
  <div class="flex flex-1 nav-wrap md:ps-[20px] md:pe-[30px] ps-[10px] pe-[15px] bg-white dark:bg-[#1b1d2a]">
    <ul class="flex items-center mb-0 list-none nav-left ps-0 gap-x-[14px] gap-y-[9px]">
      <li class="desktop-toggle">
        <a class="flex items-center justify-center w-[40px] h-[40px] rounded-full bg-transparent hover:bg-primary/10 hover:text-primary group transition duration-200 ease-in-out text-[#525768] dark:text-white/60 dark:hover:bg-white/10" (click)="toggleFold()">
          <svg-icon [ngClass]="{
            'is-folded': isFolded,
            'is-expand' : isExpand
          }" class="[&>svg]:w-[20px] text-current [&.is-folded>svg]:hidden" src="assets/images/svg/align-center-alt.svg" />
          <svg-icon [ngClass]="{
            'is-folded': isFolded,
            'is-expand' : isExpand
          }" class="[&>svg]:w-[20px] text-current [&>svg]:hidden [&.is-folded>svg]:block" src="assets/images/svg/align-left.svg" />
        </a>
      </li>
      <li class="mobile-toggle">
        <a class="flex items-center justify-center w-[40px] h-[40px] rounded-full bg-transparent hover:bg-primary/10 hover:text-primary group transition duration-200 ease-in-out text-[#525768] dark:text-white/60 dark:hover:bg-white/10" (click)="toggleExpand()">
          <svg-icon [ngClass]="{
            'is-folded': isFolded,
            'is-expand' : isExpand
          }" class="[&>svg]:w-[20px] text-current [&.is-expand>svg]:hidden" src="assets/images/svg/align-center-alt.svg" />
          <svg-icon [ngClass]="{
            'is-folded': isFolded,
            'is-expand' : isExpand
          }" class="[&>svg]:w-[20px] text-current [&>svg]:hidden [&.is-expand>svg]:block" src="assets/images/svg/align-left.svg" />
        </a>
      </li>
    </ul>

    <app-menu></app-menu>
  </div>
</div>
